import { Injectable } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { ExtraOptionsGetterState } from "../ngxs/extra-options/extra-options-getter.state";
import { Observable } from "rxjs";
import { IMetaOption } from "../interfaces/meta-options.interface";
import { GetExtraOptionsRequestState } from "../ngxs/extra-options/extra-options.state";
import { IRequest } from "ngxs-requests-plugin";
import { GetExtraOptions } from "../ngxs/extra-options/extra-options.actions";

@Injectable({
  providedIn: 'root',
})
export class ExtraOptionsService {
  @Select(ExtraOptionsGetterState.getExtraOptions)
  extraOptions$: Observable<IMetaOption[]>;

  @Select(GetExtraOptionsRequestState)
  getExtraOptionsRequestState$: Observable<IRequest>;

  constructor(
    private store: Store
  ) {}

  getExtraOptions() {
    this.store.dispatch(new GetExtraOptions());
  }

  getExtraOptionsSnapshot() {
    return this.store.selectSnapshot(ExtraOptionsGetterState.getExtraOptions);
  }

  getExtraOptionDefaults(): {[key: string]: any} {
    const extraOptions = this.getExtraOptionsSnapshot();
    const defaults = {};
    extraOptions.forEach(option => {
      defaults[option.tag] = option.default_tag;
    });
    return defaults;
  }
}